import config from "../../config.json";
import React, { createContext, useContext, useState,useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
       const [userObjId, setUserObjId] = useState(localStorage.getItem("userObjId") || null);
       const [newUser, setNewUser] = useState(null);
      const [userEmail, setUserEmail] = useState(localStorage.getItem("userEmail") || null);
       const [pricingPlans, setPricingPlans]=useState(null);
       const [profileData, setProfileData] = useState({});
       const [userAnalytics, setUserAnalytics]= useState({})
       const [jdData, setJdData] = useState([]);
       const [resumes, setResumes] = useState([]);
       const [prepsessions, setPrepSessions] = useState([]);
       const [mocksessions,setMockSessions]=useState([]);
       const [userRole, setUserRole] = useState(localStorage.getItem("userRole") || null);

      //  const [theme, setTheme]= useState(localStorage.getItem("theme") || "dark");
      const [portalTheme, setPortalTheme] = useState(() => {
        return localStorage.getItem("portalTheme") || "light";
    });
    const [walletData, setWalletData] = useState(null);


      //  useEffect(()=>{
      //   let root=document.documentElement;
      //   if(theme==="dark"){
      //     localStorage.setItem("theme", "dark");
      //     root.setAttribute("theme", "dark")
      //   }else{
      //     localStorage.setItem("theme", "light");
      //     root.setAttribute("theme", "light")
      //   }
      //  },[theme])



           // Apply theme only when in portal
    const applyPortalTheme = (theme) => {
      let root = document.documentElement;
      localStorage.setItem("portalTheme", theme);
      root.setAttribute("theme", theme);
      setPortalTheme(theme);
  };

  // Set dark theme for website (non-portal pages)
  const applyWebsiteTheme = () => {
      let root = document.documentElement;
      root.setAttribute("theme", "dark");
  };
      
       const fetchPricingData= async()=>{
        try{
          let response= await fetch(`${config.restAPI}/accounts/getPlans/`, {
            method:"GET",
            credentials:"include",
          })
          let data=await response.json();
          setPricingPlans(data);
        }
        catch(error){
          console.log("error in fetching pricing data:", error);
        }
      }

      const fetchWallet = async () => {
        if (!userObjId) return;
        try {
          const response = await fetch(`${config.restAPI}/credits/get-user-wallet/`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_obj_id: userObjId }),
          });
          if (!response.ok) throw new Error('Failed to fetch wallet');
          const data = await response.json();
          setWalletData(data);
        } catch (error) {
          console.error('Error fetching wallet:', error);
        }
      };

    useEffect(() => {
        if (userObjId) {
            localStorage.setItem("userObjId", userObjId);
        }
    }, [userObjId]);  

    useEffect(() => {
      if (userEmail) {
        localStorage.setItem("userEmail", userEmail);
      }
    }, [userEmail]);

    useEffect(() => {
      if (userObjId) fetchWallet();
    }, [userObjId]);

    const onLogout=()=>{
      setUserObjId(null);
      setUserAnalytics({});
      setUserEmail(null);
      setUserRole(null);
      setProfileData({});
    }

    return (
        <AuthContext.Provider value={{ 
          userObjId, setUserObjId, newUser ,setNewUser , userEmail, setUserEmail, pricingPlans, setPricingPlans, 
          fetchPricingData,
          profileData, 
          setProfileData,
          userAnalytics, 
          setUserAnalytics,
          onLogout,
          walletData, setWalletData,
          fetchWallet,
          jdData, setJdData,
          resumes, setResumes,
          prepsessions, setPrepSessions,
          mocksessions,setMockSessions,
          portalTheme,
          setPortalTheme: applyPortalTheme,
          applyWebsiteTheme,
          setUserRole,
          userRole
          }}>
            {children}
        </AuthContext.Provider>
    );
};

// Custom hook to use the AuthContext
export const useAuthContext = () => useContext(AuthContext);